var $ = require("./lib/qsa");
require("./analytics");
var debounce = require("./lib/debounce");
var { timer } = require("./lib/timer.js");
var { Player } = require("./player.js");
const { animateScroll } = require("./lib/animate.js");
const { getGeo, renderMap, moveCircle } = require("./map.js");

const { getStation, setStation } = require("./branding.js");

var animationTimer = new timer();
var player = new Player(animationTimer);

var currIndex;
var dataLen;

getStation().then(setStation);


getGeo().then(function (geo) {
  window.scrollTo(0, 0);

  var shuffledData = shuffleArray(DATA);
  dataLen = shuffledData.length;
  render(geo, shuffledData);

  window.addEventListener("resize", handleResize);
});

var render = function (data, obits) {
  var container = "#map-container";

  renderMap({
    container,
    data,
    obits,
  });

  $.one("#start-button").addEventListener("click", () => handleResume(0));
  document.addEventListener("scroll", debounce(handleScroll));

  player.pause();
};

function handleResume(index) {
  player.play();
  animateScrollWrapper(index, 0);
}

function animateScrollWrapper(index, time) {
  if (index >= dataLen) {
    showAbout(null, 5000);
    return;
  }
  animateScroll($.one("#mem-text-" + index), time);
}

function showAbout(e, opt_time) {
  // Scroll to about page
  animateScroll($.one("#end-wrapper"), opt_time || 0);
}

// Shuffle the data and reorg the text elements.
function shuffleArray(arr) {
  var memorialParent = $.one("#memorial-text-wrapper");
  var children = memorialParent.children;
  var shuffled = [];
  var ul = document.querySelector("ul");
  var index = 0;

  for (var i = children.length; i > 0; i--) {
    var rand = (Math.random() * i) | 0;
    children[rand].id = `mem-text-${index}`;
    var content = Array.from(children[rand].children);
    content.forEach(d => (d.dataset.num = index));
    children[rand].dataset.num = index;
    memorialParent.appendChild(children[rand]);

    shuffled.push({ lng: arr[rand].lng, lat: arr[rand].lat });
    arr.splice(rand, 1);

    index++;
  }
  return shuffled;
}

function handleClick() {
  // Begin animation
  animateScrollWrapper(0, 3000);
}

var showNext = async function (index) {
  // If we're not on an obituary, return.
  currIndex = index;

  if (isNaN(index) || index < 0) {
    return;
  }

  player.resetTime();

  $.one("#mem-text-" + index).classList.add("entering", "active");

  moveCircle(index);

  // Show circles and text, then fade out
  $.one(".circles").classList.add("entering");
  showDots(index, dataLen);

  animationTimer.set(() => fadeOut(index), 7000);
};

var fadeOut = function (index) {
  if (currIndex != index) return;
  var text = $.one("#mem-text-" + index);

  var circles = $.one(".circles");
  circles.classList.remove("entering");
  circles.classList.add("exiting");

  text.classList.add("exiting");

  animationTimer.set(() => exitFrame(index), 3000);
};

var exitFrame = function (index) {
    $.one(".circles").classList.remove("exiting");
    $.one("#mem-text-" + index).classList.remove("entering", "active");
    animateScrollWrapper(index + 1, 3000);
  }

// Show the progress bar and map circles depending on where we are the in
// the scroll.
var showDots = function (index, arrLen) {
  // TODO: try to do this more efficiently.
  for (let i = 0; i < arrLen; i++) {
    var circle = $.one("#stay-circle-" + i);
    if (i <= index) {
      circle.classList.add("entering");
    } else {
      circle.classList.remove("entering");
    }
  }
};

function handleScroll() {
  topVisible(isInViewport($.one("#intro-item"))); 
  bottomVisible(isInViewport($.one("#end-item")));
  var index = getClosestElementToMap();

  // If we're on a new element, show it.
  if (index === currIndex) return;

  $.one("#progress-bar").style.width = (index / (dataLen - 1)) * 100 + "%";
  var current = $.one(".memorial-text.entering");
  if (current) current.classList.remove("entering", "active");
  current = $.one(".memorial-text.exiting");
  if (current) current.classList.remove("exiting");

  showNext(index);
}

// Find closest element to the map top so we can display that.
function getClosestElementToMap() {
  var memorialParent = $.one("#memorial-text-wrapper");
  var memorials = Array.from(memorialParent.children);
  var reversed = memorials.slice().reverse();
  var mapBounds = $.one("#map-container").getBoundingClientRect();

  for (var m of reversed) {
    var bottom = m.getBoundingClientRect().bottom;

    if (bottom > 0 && bottom < mapBounds.top + 110) {
      return Number(m.dataset.num);
    }
  }

  return -1;
}

// Update svg width on resize when necesssary.
var handleResize = function () {
  if (window.scrollY > 0) handleScroll();
};

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
};

window.addEventListener("visibilitychange", function() {
  if (document.visibilityState == "hidden") {
    // cancel any pending timers
    player.pause();
  }
});

var topVisible = function (visibility) {
  document.body.classList.toggle("engaged", !visibility);
  if (visibility) animationTimer.stop();
}

var bottomVisible = function (visibility) {
  document.body.classList.toggle("ended", visibility);
  if (visibility) {
    $.one("#progress-bar").style.width = "100%";
    animationTimer.stop();
  }
}

function isInViewport(elm) {
  var rect = elm.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}
